import React from 'react';

import { Checkbox, HStack, Spacer, Text } from '../../../core-ui';
import formatCurrency from '../../../core/support/formatCurrency';
import { GetFeesAndSales_flatFees } from './__generated__/GetFeesAndSales';

type Props = {
  feeColumn: GetFeesAndSales_flatFees;
  flatFee: number;
  updateFlatFee: (amountInCents: number) => void;
};

export function FeeCheckbox(props: Props) {
  const { feeColumn, flatFee, updateFlatFee } = props;

  const feeId = feeColumn.id;

  return (
    <Checkbox
      defaultChecked={flatFee === feeColumn.amountInCents}
      onChange={(e) => {
        const newAmountInCents = e.target.checked ? feeColumn.amountInCents : 0;
        updateFlatFee(newAmountInCents);
      }}
    >
      <HStack key={feeId}>
        <Text>{feeColumn.name}</Text>
        <Spacer />
        <Text>{formatCurrency(feeColumn.amountInCents)}</Text>
      </HStack>
    </Checkbox>
  );
}
